import React from 'react'
import Svg, { Circle, Path } from 'react-native-svg'

interface Props {
  width?: number
  height?: number
}

const WrongIcon: React.FC<Props> = ({ width = 50, height = 50 }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 50 50" fill="none">
      {/* Red circle background */}
      <Circle cx="24.996" cy="24.996" r="24.996" fill="#CC293F" />

      {/* White "X" shape */}
      <Path
        fill="#fff"
        d="M26.762 24.956 37.13 14.49a1.289 1.289 0 0 0-.083-1.716 1.258 1.258 0 0 0-1.697-.084L24.998 23.172 14.646 12.69a1.255 1.255 0 0 0-1.697.084 1.286 1.286 0 0 0-.083 1.716l10.368 10.467-10.368 10.468a1.286 1.286 0 0 0 0 1.8 1.273 1.273 0 0 0 1.78 0l10.352-10.483L35.35 37.224a1.273 1.273 0 0 0 1.78 0 1.287 1.287 0 0 0 0-1.8L26.762 24.956Z"
      />
      <Path
        stroke="#fff"
        d="M26.762 24.956 37.13 14.49a1.289 1.289 0 0 0-.083-1.716 1.258 1.258 0 0 0-1.697-.084L24.998 23.172 14.646 12.69a1.255 1.255 0 0 0-1.697.084 1.286 1.286 0 0 0-.083 1.716l10.368 10.467-10.368 10.468a1.286 1.286 0 0 0 0 1.8 1.273 1.273 0 0 0 1.78 0l10.352-10.483L35.35 37.224a1.273 1.273 0 0 0 1.78 0 1.287 1.287 0 0 0 0-1.8L26.762 24.956Z"
      />
    </Svg>
  )
}

export default WrongIcon
